import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timeoutId = window.setTimeout(() => this.openModal(), this.delayValue)
  }

  disconnect() {
    window.clearTimeout(this.timeoutId)
  }

  openModal() {
    if (!this.hasModalTarget) return
    const modalElement = this.modalTarget.firstElementChild || this.modalTarget
    modalElement.dispatchEvent(new CustomEvent("demo-modal:open"))
  }
}
